import {Component, Input} from '@angular/core';
import {HomeContent} from "../../interfaces/home-content";
import {HelpfulLink} from "../../interfaces/helpful-link";

@Component({
  selector: 'brt-filtered-links-list',
  templateUrl: './filtered-links-list.component.html',
  styleUrls: ['./filtered-links-list.component.scss']
})
export class FilteredLinksListComponent {

  @Input('home-content') set setHomeContent(content: HomeContent) {
    if(content) {
      let helpfulLinks = [...content.helpfulLinks];

      helpfulLinks = helpfulLinks.sort((a,b) => {
        if(a.position === b.position) return 0;
        return (a.position < b.position) ? -1 : 1;
      });

      const teacherLinks: HelpfulLink[] = [];
      const companyLinks: HelpfulLink[] = [];
      helpfulLinks.forEach((link) => {
        if(link.type === "LEHRPERSON") {
          teacherLinks.push(link);
        } else if(link.type === "UNTERNEHMEN") {
          companyLinks.push(link);
        }
      });

      this.teacherLinks = teacherLinks;
      this.companyLinks = companyLinks;
    }
  }

  homeContent!: HomeContent;

  activeList = "teachers"

  teacherLinks: HelpfulLink[] = []

  companyLinks: HelpfulLink[] = [];

}
